import { useParams } from 'react-router-dom';
import { findCounty } from '../../lib/serviceAreas';
import { AreaPageLayout } from '../../components/AreaPageLayout';
import { NotFoundArea } from './NotFoundArea';

export const CountyPage = () => {
  const { slug } = useParams();
  const county = findCounty(slug);
  if (!county) return <NotFoundArea />;
  return <AreaPageLayout kind="county" area={county} />;
};
